<div class="order-list-container">
  @if (isOperator()) {
  <div class="operator-toolbar">
    <form class="search" [formGroup]="searchForm" novalidate (ngSubmit)="onSubmit()">
      <div class="search-toolbar-container">
        <span [ngClass]="minimumState() ? 'hidden' : ''">{{ "SUBSCRIPTIONS_LIST" | translate }}</span>
        <mat-form-field style="flex: 1">
          <button mat-icon-button matPrefix type="submit" ngDefaultControl [matTooltip]="'SEARCH' | translate">
            <mat-icon>search</mat-icon>
          </button>
          <input #searchtext type="text" [placeholder]="'SEARCH_PLACEHOLDER' | translate" autocomplete="off"
            spellcheck="false" matNativeControl formControlName="searchText" />
          <button mat-icon-button matSuffix type="button" [matTooltip]="'SEARCH_CLEAR' | translate"
            (click)="resetSearch()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="order-filter-container">
        <div id="filter-all" class="order-filter-button material-icon-filled"
          [class.active]="activeOrderFilter() === 'filter-all'" (click)="onOrderTypeFilterPressed(OrderFilterType.ALL)">
          <mat-icon>select_all</mat-icon>
          <span translate>ADMIN.FILTER.ALL</span>
        </div>

        <div id="filter-single" class="order-filter-button material-icon-filled"
          [class.active]="activeOrderFilter() === 'filter-single'"
          (click)="onOrderTypeFilterPressed(OrderFilterType.SINGLE)">
          <mat-icon>person</mat-icon>
          <span translate>ADMIN.FILTER.SINGLE</span>
        </div>

        <div id="filter-multiple" class="order-filter-button material-icon-filled"
          [class.active]="activeOrderFilter() === 'filter-multiple'"
          (click)="onOrderTypeFilterPressed(OrderFilterType.MULTIPLE)">
          <mat-icon>groups_2</mat-icon>
          <span translate>ADMIN.FILTER.MULTIPLE</span>
        </div>
        <div id="filter-domain" class="order-filter-button material-icon-filled"
          [class.active]="activeOrderFilter() === 'filter-domain'"
          (click)="onOrderTypeFilterPressed(OrderFilterType.DOMAIN)">
          <mat-icon>domain</mat-icon>
          <span translate>ADMIN.FILTER.DOMAIN</span>
        </div>
        <div id="filter-demo" class="order-filter-button material-icon-filled"
          [class.active]="activeOrderFilter() === 'filter-demo'"
          (click)="onOrderTypeFilterPressed(OrderFilterType.DEMO)">
          <mat-icon>timelapse</mat-icon>
          <span translate>ADMIN.FILTER.DEMO</span>
        </div>

        <div class="bubble-hover"></div>

        <div class="bubble-active" [style.position-anchor]="'--' + activeOrderFilter()"></div>
      </div>
    </form>
  </div>
  }

  <div class="scrollable-content">
    @if (noList()) {
    <div>
      <span>{{ "NO_SUBSCRIPTIONS" | translate }}</span>
    </div>
    } @else {
    <div>
      <mat-accordion [multi]="true">
        @for (subscription of activeSubscriptions(); track subscription.order.subscriptionId; let i = $index; let
        isFirst = $first) {
        <app-order [subscription]="subscription" [expanded]="subscription.panelOpenState" [compressed]="compressed()"
          [medium]="medium()" [minimumState]="minimumState()" [isOperator]="isOperator()" [canSendMail]="canSendMail()"
          [canEditOrder]="canEditOrder()" [canDeleteSubscription]="canDeleteSubscription()"
          [enabledDetail]="enabledDetail()" [searchedText]="searchedText()"
          (configAccessClick)="configAccess(subscription)" (openStatsClick)="openStats(subscription)"
          (renewClick)="renewSubscription(subscription)" (buyCreditsClick)="buyAiCredits(subscription)"
          (deleteClick)="deleteSubscription(subscription)" (panelOpened)="panelOpenState(subscription, true)"
          (panelClosed)="panelOpenState(subscription, false)" (orderUpdated)="reloadData()"> </app-order>
        }
      </mat-accordion>
      @if (expiredSubscriptions().length > 0) {
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; gap: 6px">
        <div>Scaduti</div>
        <mat-divider style="flex-grow: 1"></mat-divider>
      </div>
      }

      <mat-accordion [multi]="true">
        @for (expiredSubscription of expiredSubscriptions(); track expiredSubscription.order.subscriptionId; let i =
        $index; let isFirst = $first) {
        <app-order [subscription]="expiredSubscription" [expanded]="expiredSubscription.panelOpenState"
          [compressed]="compressed()" [medium]="medium()" [minimumState]="minimumState()" [isOperator]="isOperator()"
          [canSendMail]="canSendMail()" [canEditOrder]="canEditOrder()"
          [canDeleteSubscription]="canDeleteSubscription()" [enabledDetail]="enabledDetail()"
          [searchedText]="searchedText()" (configAccessClick)="configAccess(expiredSubscription)"
          (openStatsClick)="openStats(expiredSubscription)" (renewClick)="renewSubscription(expiredSubscription)"
          (buyCreditsClick)="buyAiCredits(expiredSubscription)" (deleteClick)="deleteSubscription(expiredSubscription)"
          (panelOpened)="panelOpenState(expiredSubscription, true)"
          (panelClosed)="panelOpenState(expiredSubscription, false)" (orderUpdated)="reloadData()"> </app-order>
        }
      </mat-accordion>
    </div>
    }
  </div>
  <div class="footer">
    <div class="legend">
      @if (hasActiveSubscriptions()) {
      <span class="active-panel" style="padding: 5px 10px 5px 10px; border-radius: 10px; flex-shrink: 0"
        translate>ACTIVE</span>
      }
      @if (hasTBDSubscriptions()) {
      <span class="tbd-panel" style="padding: 5px 10px 5px 10px; border-radius: 10px; flex-shrink: 0"
        translate>TBD</span>
      }
      @if (hasInvalidSubscriptions()) {
      <span class="invalid-panel" style="padding: 5px 10px 5px 10px; border-radius: 10px; flex-shrink: 0"
        translate>ACCESSCONFIG_ORDER_EXPIRED</span>
      }
      @if (hasRedirectSubscriptions()) {
      <span class="redirect-panel" style="padding: 5px 10px 5px 10px; border-radius: 10px; flex-shrink: 0"
        translate>REDIRECT</span>
      }
    </div>
    @if (isOperator()) {
    @if (isLoaded() && length() > 0) {
    <mat-paginator #paginator [showFirstLastButtons]="true" [length]="length()" [pageSize]="pageSize()"
      [pageIndex]="pageIndex()" (page)="changePage($event)"></mat-paginator>
    }
    }
  </div>
</div>